// @ts-ignore
/* eslint-disable */
import { request } from '@umijs/max';

/** 点击事件上报接口 POST /api/statis/userClickEvent/reportClickEvent */
export async function reportClickEvent(
  data: { clickEventKey: string; clickEventType: 1 | 2 },
  options?: { [key: string]: any },
) {
  return request<API.RESPONSE>('/api/statis/userClickEvent/reportClickEvent', {
    method: 'POST',
    data,
    skipErrorHandler: true,
    ...(options || {}),
  });
}

/** 心跳接口 POST /api/user/public/heartbeat */
export async function heartbeat(options?: { [key: string]: any }) {
  return request<API.RESPONSE>('/api/user/public/heartbeat', {
    method: 'POST',
    skipErrorHandler: true,
    data: {},
    ...(options || {}),
  });
}
